import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCircle1, faCircle2, faCircle3 } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Inline, Inset } from 'syf-component-library/ui/spacing';
import { StyledFlex } from '../../../../styles/common';
import { StyledText } from '../../../../styles/text';
import { colors } from '../../../../styles/theme';
import { StyledAccordionList, StyledAccordionListContainer } from '../subcomponents';
var accordionListIcons = {
    1: faCircle1,
    2: faCircle2,
    3: faCircle3
};
export var ListItem = function (_a) {
    var text = _a.text, bulletValue = _a.bulletValue;
    return (_jsxs(StyledFlex, { alignItems: "start", children: [_jsx(Inset, { top: "xsmall", children: _jsx(FontAwesomeIcon, { title: "bullet-".concat(bulletValue), size: "lg", color: colors.success, icon: accordionListIcons[bulletValue] }) }), _jsx(Inline, { size: "small" }), _jsx(StyledText, { children: text })] }));
};
var BulletedContent = function () {
    var t = useTranslation().t;
    var list = [
        t('selectPay.selectTransactionBullet1Text'),
        t('selectPay.selectTransactionBullet2Text'),
        t('selectPay.selectTransactionBullet3Text')
    ];
    return (_jsx(StyledAccordionListContainer, { children: _jsx(StyledAccordionList, { direction: "column", children: list.map(function (item, index) {
                return _jsx(ListItem, { text: item, bulletValue: index + 1 }, item);
            }) }) }));
};
export default BulletedContent;
//# sourceMappingURL=index.js.map